import React, { memo } from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
const without = ['Studi senza sapere cosa dare priorità', "Ti blocchi sui dosaggi all'esame", 'Arrivi in clinica con paura', 'Confondi farmaci pericolosi nei gatti', 'Non sai compilare una cartella clinica', "Ti paralizzi in un'emergenza", 'Improvvisi parlando con il proprietario'];
const withProduct = ['Sai esattamente cosa memorizzare', 'Calcoli i dosaggi con sicurezza', 'Entri con criterio e fiducia', 'Conosci ogni controindicazione critica', "Hai modelli pronti all'uso", 'Applichi protocolli passo per passo', 'Comunichi da professionista dal primo giorno'];
export function Comparison() {
  return <section className="w-full py-12 px-4 bg-white" data-id="element-40">
      <div className="max-w-4xl mx-auto" data-id="element-41">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-center text-slate-900" data-id="element-42">
          La differenza è enorme
        </h2>

        <div className="grid grid-cols-2 gap-3 sm:gap-5 mt-6" data-id="element-43">
          {/* SENZA */}
          <div className="rounded-xl border-2 border-red-200 bg-red-50/50 overflow-hidden" data-id="element-44">
            <div className="bg-red-600 text-white px-3 sm:px-5 py-2.5" data-id="element-45">
              <h3 className="font-extrabold text-sm sm:text-lg flex items-center gap-1.5" data-id="element-46">
                <XIcon className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-47" />{' '}
                <span data-id="element-48">SENZA il pack</span>
              </h3>
            </div>
            <ul className="p-3 sm:p-4 space-y-2" data-id="element-49">
              {without.map((t, i) => <li key={i} className="flex items-start gap-2" data-id="element-50">
                  <span className="flex-shrink-0 w-4 h-4 sm:w-5 sm:h-5 rounded-full bg-red-100 border border-red-300 flex items-center justify-center mt-0.5" data-id="element-51">
                    <XIcon className="w-2.5 h-2.5 sm:w-3 sm:h-3 text-red-700" data-id="element-52" />
                  </span>
                  <span className="text-red-800 font-medium text-xs sm:text-sm leading-snug" data-id="element-53">
                    {t}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* CON */}
          <div className="rounded-xl border-2 border-green-300 bg-green-50/50 overflow-hidden shadow-md shadow-green-100" data-id="element-54">
            <div className="bg-green-600 text-white px-3 sm:px-5 py-2.5" data-id="element-55">
              <h3 className="font-extrabold text-sm sm:text-lg flex items-center gap-1.5" data-id="element-56">
                <CheckIcon className="w-4 h-4 sm:w-5 sm:h-5" data-id="element-57" />{' '}
                <span data-id="element-58">CON il pack</span>
              </h3>
            </div>
            <ul className="p-3 sm:p-4 space-y-2" data-id="element-59">
              {withProduct.map((t, i) => <li key={i} className="flex items-start gap-2" data-id="element-60">
                  <span className="flex-shrink-0 w-4 h-4 sm:w-5 sm:h-5 rounded-full bg-green-100 border border-green-300 flex items-center justify-center mt-0.5" data-id="element-61">
                    <CheckIcon className="w-2.5 h-2.5 sm:w-3 sm:h-3 text-green-700" data-id="element-62" />
                  </span>
                  <span className="text-green-900 font-medium text-xs sm:text-sm leading-snug" data-id="element-63">
                    {t}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}